// import React from "react";
// import ComingSoonCard from "./comingSoonCard";

// const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

// const GamingView = () => {
//   return (
//     <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20 }}>
//       <p style={{ fontSize: 20, fontWeight: "bold" }}>Gaming</p>
//       <ComingSoonCard
//         imgWidth={130}
//         imgUrl={`${SERVER_URL}/assets/images/game_icon.png`}
//         mainText='Games & More'
//         subText='Enjoy exciting games on Pulse! This
// feature is coming soon.'
//       />
//     </div>
//   );
// };

// export default GamingView;

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLoyalty, useTheme, useTrivia } from "../../hooks/";
import {
  CurveHolder,
  FooterImage,
  FooterImageContainer,
  StyledText,
} from "../../components/common/basic";
import { useHistory } from "react-router-dom";
import OfferCards from "../loyalty/offerCards";
import { Curve, CurveOverImage } from "../svgs";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { FeatureRatingsModal, OfferCard } from "../loyalty";
import TriviaRatingModal from "../../screens/subscriber/trivia/triviaRating/TriviaRatingModal";
import FastestFingerInfoModal from "../../screens/subscriber/fastestFinger/components/fastestFingerInfoModal";
import useFastestFinger from "../../hooks/useFastestFinger";

const GamingView = () => {
  const { themeContext, theme } = useTheme();
  const { fastestFingerData } = useFastestFinger();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const history = useHistory();

  const { triviaRating, setTriviaRatingModal } = useTrivia();

  const [openFastestFingerInfoModal, setOpenFastestFingerInfoModal] =
    useState(false);

  useEffect(() => {
    if (fastestFingerData) {
      setOpenFastestFingerInfoModal(true);
    }
  }, [fastestFingerData]);

  const tips = [
    `Only users of the ages 15 - 35 years are eligible to access the MTN Pulse Section on myMTN App`,
    `Some Mashup bundles have packages with more talk time to connect to your girls and homies.`,
    `You can convert Mashup voice bundle to data.`,
    // `You can opt for a Mashup bundle package with more data.`,
    // `All Mashup bundles have freebies for social media`,
    // `Only mashup bundle GHC 0.07 to GHC 5.00 comes with a WhatsApp freebie.`,
    // `The GHC 5 to GHC 30 mashup bundles have WhatsApp, Twitter, Facebook, IG, WeChat, TikTok, SMS freebies.`,
    // `Pulse gives you the power to purchase flexible bundles for yourself, family and friends.`,
    // `You can mashup for family and friends on myMTN App`,
    // `You can view the history of all your mashup purchases on myMTN App`,
    // `MTN Pulse has loyalty partners who provide discount to users who generate the discount loyalty code on the app`,
    // `Yango, Potbelly and Silverbird cinemas are MTN Pulse loyalty partners`,
    // `You can enjoy a 5 % discount on Yango rides every Wednesday`,
    // `You can enjoy up to 20 % discount on Potbelly Shack meals every Monday to Thursday`,
    // `Mondays are juicy with 50 % discounts on movie tickets at the Silverbird cinemas`,
    // `Pulse Movie Mania allows you to generate a 100 % free Silverbird Cinema movie ticket`,
    // `Username definition is allowed by tabbing on profile to set it up`,
    // `Trivia Tuesday is played on Tuesday’s only`,
    // `Rewards are given to successful trivia players`,
  ];

  const newTrivis = [
    {
      image:
        "https://res.cloudinary.com/dhmljeapc/image/upload/v1695228149/Pulse/Mask_Group_u6crmw.png",
      title: "Pulse Trivia",
      description: "Answer questions and win amazing prices",
    },
  ];

  const submitFeatureRatings = () => {};
  const hideNewFeatureRatings = () => {};

  return (
    <>
      <OfferHeader>
        <StyledText style={{ fontSize: "18px", fontWeight: "bold" }}>
          Pulse Games
        </StyledText>
      </OfferHeader>
      <div
        style={{
          display: "grid",
          gap: "0px",
          grid: "auto / 50% 50%",
          maxWidth: "370px",
          margin: "0 auto",
        }}
      >
        {newTrivis.map((trivia) => (
          <OfferCard
            cardMargin="10px auto"
            backgroundImage={trivia.image}
            description={trivia.description}
            title={trivia.title}
            onClick={() => history.push(`/trivia/trivia-category`)}
          />
        ))}
      </div>

      <FooterImageContainer>
        <div
          style={{
            width: "100%",
            // height: 270,
            backgroundColor: "black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop:'15%',
            paddingLeft: 20,
          }}
        >
          <div>
            <StyledText color="white">Did you know?</StyledText>
          </div>

          <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false}>
            {tips.map((message, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "white",
                  width: "90%",
                  borderRadius: 10,
                  paddingTop: 8,
                  marginBottom: '8%',
                }}
              >
                <StyledText>{message}</StyledText>
              </div>
            ))}
          </Carousel>
        </div>
      </FooterImageContainer>

      {/* {triviaRating && (
        <TriviaRatingModal onNotNowClick={() => setTriviaRatingModal(false)} />
      )} */}

      {openFastestFingerInfoModal && (
        <FastestFingerInfoModal
          onBackDropClick={() => setOpenFastestFingerInfoModal(false)}
        />
      )}
    </>
  );
};

export default GamingView;

const OfferHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 20px;
`;

const ViewAllHolder = styled.div`
  text-align: center;
  cursor: pointer;
`;
